// extracted by mini-css-extract-plugin
module.exports = {"root":"FormLoginEmail_root__piZzH","mailIcon":"FormLoginEmail_mailIcon__5TSdj","input":"FormLoginEmail_input__tsxra"};